import React, { useState, useEffect } from 'react';
import './RankSearch.css';

// 샘플 데이터를 컴포넌트 외부로 이동
const sampleData = [
  {
    id: 1,
    companyName: '배달의민족***',
    keyword: '음식주문***',
    initialRank: 6,
    currentRank: 1,
    searchDate: '2025-07-22 16:07:18'
  },
  {
    id: 2,
    companyName: '카카오***',
    keyword: '카톡***',
    initialRank: 8,
    currentRank: 2,
    searchDate: '2025-07-22 11:45:32'
  },
  {
    id: 3,
    companyName: '토스***',
    keyword: '금융***',
    initialRank: 9,
    currentRank: 2,
    searchDate: '2025-07-22 20:41:33'
  },
  {
    id: 4,
    companyName: '삼성***',
    keyword: '갤럭시***',
    initialRank: 15,
    currentRank: 3,
    searchDate: '2025-07-22 09:23:15'
  },
  {
    id: 5,
    companyName: '롯데***',
    keyword: '백화점***',
    initialRank: 11,
    currentRank: 3,
    searchDate: '2025-07-23 10:38:22'
  },
  {
    id: 6,
    companyName: '쿠팡***',
    keyword: '배송***',
    initialRank: 20,
    currentRank: 4,
    searchDate: '2025-07-22 14:33:27'
  },
  {
    id: 7,
    companyName: '이마트***',
    keyword: '대형마트***',
    initialRank: 13,
    currentRank: 4,
    searchDate: '2025-07-23 15:44:12'
  },
  {
    id: 8,
    companyName: 'LG전자***',
    keyword: '가전제품***',
    initialRank: 18,
    currentRank: 5,
    searchDate: '2025-07-22 19:24:55'
  },
  {
    id: 9,
    companyName: '네이버***',
    keyword: '검색엔진***',
    initialRank: 12,
    currentRank: 6,
    searchDate: '2025-07-23 08:15:42'
  },
  {
    id: 10,
    companyName: '현대자동차***',
    keyword: '자동차***',
    initialRank: 25,
    currentRank: 7,
    searchDate: '2025-07-22 13:28:33'
  },
  {
    id: 11,
    companyName: 'SK텔레콤***',
    keyword: '통신***',
    initialRank: 16,
    currentRank: 8,
    searchDate: '2025-07-23 12:45:18'
  },
  {
    id: 12,
    companyName: '신한은행***',
    keyword: '은행***',
    initialRank: 22,
    currentRank: 9,
    searchDate: '2025-07-22 17:32:55'
  },
  {
    id: 13,
    companyName: '하나은행***',
    keyword: '금융서비스***',
    initialRank: 19,
    currentRank: 10,
    searchDate: '2025-07-23 14:18:27'
  },
  {
    id: 14,
    companyName: 'CJ대한통운***',
    keyword: '택배***',
    initialRank: 24,
    currentRank: 11,
    searchDate: '2025-07-22 09:47:38'
  },
  {
    id: 15,
    companyName: '올리브영***',
    keyword: '화장품***',
    initialRank: 17,
    currentRank: 12,
    searchDate: '2025-07-23 16:22:14'
  },
  {
    id: 16,
    companyName: 'GS25***',
    keyword: '편의점***',
    initialRank: 28,
    currentRank: 13,
    searchDate: '2025-07-22 11:55:29'
  },
  {
    id: 17,
    companyName: '교보문고***',
    keyword: '도서***',
    initialRank: 21,
    currentRank: 14,
    searchDate: '2025-07-23 13:08:46'
  },
  {
    id: 18,
    companyName: '메가커피***',
    keyword: '커피***',
    initialRank: 30,
    currentRank: 15,
    searchDate: '2025-07-22 15:41:32'
  },
  {
    id: 19,
    companyName: '홈플러스***',
    keyword: '대형마트***',
    initialRank: 26,
    currentRank: 16,
    searchDate: '2025-07-23 09:17:58'
  },
  {
    id: 20,
    companyName: '아모레퍼시픽***',
    keyword: '화장품***',
    initialRank: 35,
    currentRank: 17,
    searchDate: '2025-07-22 14:29:41'
  },
  {
    id: 21,
    companyName: '스타벅스***',
    keyword: '커피전문점***',
    initialRank: 23,
    currentRank: 18,
    searchDate: '2025-07-23 11:33:25'
  },
  {
    id: 22,
    companyName: '파리바게뜨***',
    keyword: '베이커리***',
    initialRank: 32,
    currentRank: 19,
    searchDate: '2025-07-22 16:52:17'
  },
  {
    id: 23,
    companyName: '무신사***',
    keyword: '패션***',
    initialRank: 27,
    currentRank: 20,
    searchDate: '2025-07-23 08:44:53'
  },
  {
    id: 24,
    companyName: '29CM***',
    keyword: '온라인쇼핑***',
    initialRank: 31,
    currentRank: 21,
    searchDate: '2025-07-22 12:16:39'
  },
  {
    id: 25,
    companyName: 'CGV***',
    keyword: '영화관***',
    initialRank: 29,
    currentRank: 22,
    searchDate: '2025-07-23 17:05:28'
  }
];

const RankSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortType, setSortType] = useState('current'); // 'current' 또는 'increase'
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    setData(sampleData);
    setFilteredData(sampleData);
    setTotalCount(sampleData.length);
  }, []); // 의존성 배열에서 sampleData 제거 (컴포넌트 외부에 있으므로)

  // 검색 기능
  useEffect(() => {
    let filtered;
    if (searchTerm === '') {
      filtered = [...data];
    } else {
      filtered = data.filter(item => 
        item.companyName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.keyword.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // 검색 후에도 현재 정렬 상태 유지
    filtered = applySorting(filtered, sortType);
    
    setFilteredData(filtered);
    setTotalCount(filtered.length);
    setCurrentPage(1);
  }, [searchTerm, data, sortType]);

  // 정렬 함수
  const applySorting = (dataToSort, type) => {
    const sorted = [...dataToSort];
    
    if (type === 'current') {
      // 현재순위 기준 오름차순 정렬 (1, 2, 3, ...)
      sorted.sort((a, b) => a.currentRank - b.currentRank);
    } else if (type === 'increase') {
      // 상승폭 기준 내림차순 정렬 (최초순위 - 현재순위)
      sorted.sort((a, b) => (b.initialRank - b.currentRank) - (a.initialRank - a.currentRank));
    }
    
    return sorted;
  };

  // 정렬 기능
  const handleSort = (type) => {
    setSortType(type);
    const sorted = applySorting(filteredData, type);
    setFilteredData(sorted);
  };

  const itemsPerPage = 8;
  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentData = filteredData.slice(startIndex, endIndex);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="rank-search-container">
      <div className="search-section">
        <div className="search-box">
          <input
            type="text"
            placeholder="검색어를 입력해 주세요."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
          <button className="search-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg>
          </button>
        </div>
      </div>

      <div className="sort-buttons">
        <button 
          className={`sort-btn ${sortType === 'current' ? 'active' : ''}`}
          onClick={() => handleSort('current')}
        >
          현재순위
        </button>
        <button 
          className={`sort-btn ${sortType === 'increase' ? 'active' : ''}`}
          onClick={() => handleSort('increase')}
        >
          상승폭
        </button>
      </div>

      <div className="table-header">
        <h2 className="table-title">
          {sortType == 'current' ? '실시간 순위 상승 성공사례 총 ' : '순위 상승폭 우수사례 총 '}
          <span className="count">{totalCount}</span> 건
        </h2>
        <p className="table-subtitle">
        *해당 성공사례 데이터가 거짓 및 허위사실인 경우 모든 민/형사상 책임 질 것을 약속드립니다.
        </p>
      </div>

      <div className="table-container">
        <table className="rank-table">
          <thead>
            <tr>
              <th>상호명</th>
              <th>키워드</th>
              <th>최초순위</th>
              <th>현재순위(상승폭)</th>
              <th>순위조회 일시</th>
            </tr>
          </thead>
          <tbody>
            {currentData.map((item) => (
              <tr key={item.id}>
                <td>{item.companyName}</td>
                <td>{item.keyword}</td>
                <td>{item.initialRank}</td>
                <td>
                  {item.currentRank} 
                  <span className="increase-indicator">
                    ▲
                  </span>
                </td>
                <td>{item.searchDate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {totalPages > 1 && (
        <div className="pagination">
          <button 
            className="page-btn"
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            ‹
          </button>
          {[...Array(totalPages)].map((_, index) => (
            <button
              key={index + 1}
              className={`page-btn ${currentPage === index + 1 ? 'active' : ''}`}
              onClick={() => handlePageChange(index + 1)}
            >
              {index + 1}
            </button>
          ))}
          <button 
            className="page-btn"
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            ›
          </button>
        </div>
      )}

      <div className="table-footer">
        <p className="footer-text">
        *데이터에 대한 저작권은 플랫폼에 있으며, 데이터 무단 도용, 배포 및 사용을 금합니다.
        </p>
        <p className="footer-text">
        무단으로 사용할 경우 법류 위반으로 손해배상청구, 형사고소 등 민,형사상의 책임을 질 수 있습니다.
        </p>
      </div>
    </div>
  );
};

export default RankSearch;